// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"3":"1a6ebe2f","22":"46b0017b"}[chunkId] + ".css";
};